import { StakeModeType, StakingType, UserCredentials, useSettings } from '@capsicum/common';

import { useCredentials } from '../../auth';

export const useFanTokenStakingConfig = (stakingType: StakeModeType | StakingType) => {
	const {
		areSettingsLoading,
		settings: { fanTokenStakingEnabled, isPoblanoEnabled, isStakeAllFanTokensEnabled }
	} = useSettings();
	const { status } = useCredentials(UserCredentials.FAN_TOKEN_STAKING_STAKE);

	const areCredentialsGranted = status === 'allowed';

	const config = {
		[StakeModeType.STAKE_ALL]:
			areCredentialsGranted && isPoblanoEnabled && fanTokenStakingEnabled.stake && isStakeAllFanTokensEnabled,
		[StakingType.CLAIM]: isPoblanoEnabled && fanTokenStakingEnabled.claim,
		[StakingType.STAKE]: areCredentialsGranted && isPoblanoEnabled && fanTokenStakingEnabled.stake,
		[StakingType.UNSTAKE]: isPoblanoEnabled && fanTokenStakingEnabled.unstake
	};

	return {
		areConfigsLoading: areSettingsLoading || status === 'loading',
		isAllowed: config[stakingType]
	};
};
